/**
 * AxiEditor 의 **유일한 문** (2026-10-14). 화면은 이것만 쓴다.
 *
 * 편집기 코드(`AxiBoardEditor`)와 배포본(약 0.6 MB + 가져오기 플러그인)은 **글을 쓰는 사람만** 받는다 —
 * 동적 `import()` 로만 부르고, 배포본은 그 안에서 다시 `<script>` 로 싣는다.
 */

import { Suspense, lazy } from 'react';
import type { AxiBoardEditorProps } from './AxiBoardEditor';

const AxiBoardEditor = lazy(() => import('./AxiBoardEditor'));

/** 내려받는 동안 자리를 지킨다 — tiptap 쪽 대기 화면과 같은 모양(`.axi-rte--loading`). */
function AxiBoardEditorFallback() {
  return <div className="axi-rte axi-rte--loading" aria-busy="true">{'편집기를 불러오는 중입니다'}</div>;
}

export function LazyAxiBoardEditor(props: AxiBoardEditorProps) {
  return (
    <Suspense fallback={<AxiBoardEditorFallback />}>
      <AxiBoardEditor {...props} />
    </Suspense>
  );
}
